import {Platform} from "react-native";
import {Button, Inline, Stack, Text, View} from "@unibuddy/patron";
import {useAnalytics} from "@unibuddy/tracking";
import {useErrorReporting} from "@unibuddy/error-reporting";
import {IconCalendar} from "@unibuddy/icons";
import {useCommunity} from "ubcommunity-shared/src/Community/CommunityProvider/CommunityProvider";
import {AdminFeatureFlags, TrackEvents} from "ubcommunity-shared/src/constants";
import {FeatureFlags} from "ubcommunity-shared/src/featureFlags";
import {useIsFeatureAdminEnabled} from "ubcommunity-shared/src/Hooks/useIsFeatureAdminEnabled";
import {useIsFeatureEnabledBoolean} from "ubcommunity-shared/src/Hooks/useIsFeatureEnabledBoolean";
import {boldFontStyles} from "ubcommunity-shared/src/Styles/fontStyles";
import {useGetGeckoUniversityQuery} from "ubcommunity-shared/src/types";
import {Routes} from "ubcommunity-shared/src/constants/routes";
import {useNavigate} from "ubcommunity-shared/src/Hooks/useNavigate";
import {useEffect} from "react";

export enum ExternalEventsRedirectStrings {
    TITLE = "Check out our upcoming events",
    DESCRIPTION = "Sign up for our virtual and in-person events to help you get prepared",
    BUTTON_TEXT = "View Events",
}

export const ExternalEventsRedirect = () => {
    const {selectedCommunity} = useCommunity();
    const {reportError} = useErrorReporting();
    const {trackEvent} = useAnalytics();
    const universityId = selectedCommunity?.institutions?.[0]?.id;

    const {navigate} = useNavigate();

    const {data, loading, error} = useGetGeckoUniversityQuery({
        variables: {
            universityId: universityId || "",
        },
        skip: !universityId,
    });
    const isFeatureEnabled = useIsFeatureEnabledBoolean(FeatureFlags.EXTERNAL_EVENTS_CTA);
    const isFeatureAdminEnabled = useIsFeatureAdminEnabled(AdminFeatureFlags.EXTERNAL_EVENTS_CTA);

    useEffect(() => {
        if (error) {
            reportError(error);
        }
    }, [error, reportError]);

    if (!isFeatureEnabled || !isFeatureAdminEnabled) return null;

    if (loading) return null;

    if (error) return null;

    if (!data?.getGeckoUniversityId) return null;

    if (!data.getGeckoUniversityId.geckoUniversityId) return null;

    const geckoUniversityId = data.getGeckoUniversityId.geckoUniversityId;
    const geckoUrl = `https://app.geckoform.com/events-embed/#/events-embed?uuid=${geckoUniversityId}&date_format=d/m/Y&time_format=g:i`;

    const handleNavigate = () => {
        trackEvent(TrackEvents.EXTERNAL_EVENTS_REDIRECT_CLICKED);
        if (Platform.OS === "web") {
            window.open(geckoUrl, "_blank");
        } else {
            navigate({
                path: Routes.EXTERNAL_EVENTS,
                options: {
                    url: geckoUrl,
                },
            });
        }
    };

    return (
        <View paddingX="small-medium" paddingTop="large">
            <Stack space="medium">
                <Text
                    style={{
                        ...boldFontStyles,
                    }}
                >
                    Upcoming Events
                </Text>
                <View
                    flex={1}
                    w="100%"
                    borderWidth={1}
                    borderColor="grey150"
                    borderRadius="small"
                    padding="medium"
                >
                    <Stack space="medium">
                        <Inline verticalAlign="center" space="small">
                            <IconCalendar />
                            <Text
                                size="large"
                                style={{
                                    ...boldFontStyles,
                                }}
                            >
                                {ExternalEventsRedirectStrings.TITLE}
                            </Text>
                        </Inline>
                        <Text>{ExternalEventsRedirectStrings.DESCRIPTION}</Text>
                        <Button color="primary" ghost onClick={handleNavigate}>
                            <Text color="primaryColor">
                                {ExternalEventsRedirectStrings.BUTTON_TEXT}
                            </Text>
                        </Button>
                    </Stack>
                </View>
            </Stack>
        </View>
    );
};
